import { Conflict, PublishScheduleConflictsProps } from '../types';
import { useTranslation } from 'react-i18next';
import { AlertDialogDescription } from '@components/ui/alert';
import { SvgConsumer } from '@components/icons/svgConsumer';
import groupBy from '@utils/groupBy';
import { PublishScheduleConfirmationCrewBox } from './crewBox';

export const PublishScheduleConfirmationConflicts = ({
  date,
  conflicts,
  name,
  summaryDetail,
}: PublishScheduleConflictsProps) => {
  const { t } = useTranslation('app', { keyPrefix: 'publisher.conflicts' });

  const groupedByCrewConflicts = () => {
    return groupBy(conflicts, (el) => el.crewId || el.assetId || el.foremanId);
  };

  if (!conflicts.length) return null;

  return (
    <>
      <AlertDialogDescription className="font-semibold text-natural-400">
        {t('title')}
      </AlertDialogDescription>
      <AlertDialogDescription>{t('description')}</AlertDialogDescription>
      <div className="flex items-center gap-2 border border-warning-400 p-1 bg-warning-50 pl-3">
        <SvgConsumer id="warning" className="text-warning-600" />
        <span className="text-warning-400 pl-2">{t('warning', { count: conflicts.length })}</span>
      </div>
      <div className="flex items-center gap-2 w-full">
        <span className="flex-none pr-1">{t('summary')}</span>
        <span className="flex-none font-semibold">{name || date}</span>
        {summaryDetail && <span className="w-full font-normal">{summaryDetail}</span>}
      </div>
      <div className="scrollbar-thin overflow-y-auto relative max-h-[200px] p-2">
        {Object.entries(groupedByCrewConflicts()).map(([crewId, crewConflicts]) => {
          return (
            <PublishScheduleConfirmationCrewBox
              key={crewId}
              crewConflicts={crewConflicts as Conflict[]}
            />
          );
        })}
      </div>
    </>
  );
};
